/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import ProductFeatureListItem from './ProductFeatureListItem'

import styled from '@emotion/styled'


const StyledSection = styled('section')`
  background-color: ${({ theme }) => theme.secondary.light};

  @media screen and (min-width: 850px) {
    background-image: url(${({ bgSrc }) => bgSrc});
    background-repeat: no-repeat;
    background-position: right top;
    background-size: contain;
  }
`

const StyledUl = styled('ul')`
  max-width: 720px;
  list-style-type: none;
  margin: 0 auto;
  padding: 16px 0 24px;

  @media screen and (min-width: 850px) {
    max-width: 850px;
  }
`

const ProductFeatureList = ({ bgSrc, children }) => (
  <StyledSection bgSrc={bgSrc}>
    <StyledUl>{children}</StyledUl>
  </StyledSection>
)

ProductFeatureList.propTypes = {
  bgSrc: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element),
}

export default ProductFeatureList
